import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { AccordionDetail as CoreAccordionDetail } from "@vds-core/accordions";

var AccordionDetail = /*#__PURE__*/function (_React$Component) {
  _inherits(AccordionDetail, _React$Component);

  var _super = _createSuper(AccordionDetail);

  function AccordionDetail(props) {
    var _this;

    _classCallCheck(this, AccordionDetail);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_calcPaddingBottom", function (viewport, opened) {
      return "23px"; // when accordion is opened
    });

    return _this;
  }

  _createClass(AccordionDetail, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(CoreAccordionDetail, _extends({}, this.props, {
        customChildrenTypography: true,
        calcPaddingBottom: this._calcPaddingBottom
      }));
    }
  }]);

  return AccordionDetail;
}(React.Component);

_defineProperty(AccordionDetail, "componentType", "AccordionDetail");

export default AccordionDetail;